import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { IIncidentCode, IUnitType, IVehicleMake } from '@/models';

import { http } from './http';

export const DataApi = {
  getIncidentCodes: async (
    agencyId?: string,
  ): Promise<AxiosResponse<IIncidentCode[]>> => {
    const params = agencyId ? { agency: agencyId } : undefined;
    return http.get(`api/${ApiVersion.V1}/incident-codes`, { params });
  },
  getVehicleMakes: (): Promise<AxiosResponse<IVehicleMake[]>> => {
    return http.get(`api/${ApiVersion.V1}/vehicles/makes`);
  },
  getUnitTypes: (
    accountScope?: boolean,
  ): Promise<AxiosResponse<IUnitType[]>> => {
    const params: any = {};

    if (accountScope) {
      params.accountScope = true;
      params.skipAgencyHeader = true;
    }

    const response = http.get(`api/${ApiVersion.V1}/units/types`, { params });
    return response;
  },
};
